import script from "./PublicStatistics.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicStatistics.vue?vue&type=script&setup=true&lang=js"

import "./PublicStatistics.vue?vue&type=style&index=0&id=3da9b5b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da9b5b1"]])

export default __exports__